import * as React from "react"
import type { IconProps } from "../types"
const TypescriptEx = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M3.75.75h7.5a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-7.5a3 3 0 0 1 3-3m4.711 11.281v-1.376q.35.315.757.471.408.157.824.157.245 0 .426-.047a1 1 0 0 0 .304-.131.522.522 0 0 0 .242-.445.56.56 0 0 0-.096-.323 1.1 1.1 0 0 0-.262-.262 2.7 2.7 0 0 0-.394-.232 13 13 0 0 0-.492-.228q-.672-.3-1.002-.735-.33-.434-.33-1.049 0-.481.18-.827.18-.345.49-.57.31-.223.718-.329Q10.234 6 10.69 6q.45 0 .795.058t.638.178v1.286a2 2 0 0 0-.314-.19 2.4 2.4 0 0 0-.709-.214 2.4 2.4 0 0 0-.338-.026q-.22 0-.4.045a1 1 0 0 0-.304.127.6.6 0 0 0-.192.195.5.5 0 0 0-.068.256q0 .155.076.277t.216.233.34.215.452.217q.345.154.619.328t.47.394q.195.22.3.5.105.282.104.656 0 .516-.182.866a1.55 1.55 0 0 1-.494.568 2.1 2.1 0 0 1-.727.311 4 4 0 0 1-.874.095q-.472 0-.898-.086a2.6 2.6 0 0 1-.739-.258m-.51-4.765H6.31v5.027H5.009V7.266H3.375V6.137h4.577z"
          clipRule="evenodd"
        />
      </svg>
    )
  }
)
TypescriptEx.displayName = "TypescriptEx"
export default TypescriptEx
